var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Multiselect',_vm._g(_vm._b({class:_vm.$style.multiselect,attrs:{"options":_vm.options,"select-label":"","deselect-label":"","show-labels":false,"searchable":true,"clear-on-select":false,"preserve-search":false},on:{"input":function($event){return _vm.$emit('update', $event)}},scopedSlots:_vm._u([{key:"tag",fn:function(ref){
var option = ref.option;
var remove = ref.remove;
return [_c('span')]}},{key:"selection",fn:function(ref){
var values = ref.values;
var search = ref.search;
var isOpen = ref.isOpen;
return [(values.length > 0 && !isOpen)?_c('span',{staticClass:"multiselect__single"},[_vm._v("\n        "+_vm._s(values.length)+" of "+_vm._s(_vm.recCount)+" option[s] selected\n      ")]):_vm._e()]}}])},'Multiselect',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }